import React from "react";
import { HeadingComponent } from "./HeadingComponent";
import { NblocksButton } from "./NblocksButton";
import { TextComponent } from "./TextComponent";
import { getCurrencySymbol, getRecurIntervalSymbol } from "../../utils/ComponentHelpers";
import { useTranslation } from "react-i18next";
const PricingCard = ({
  name,
  description,
  selected,
  didSelect,
  price,
  trial,
  trialDays,
  loading
}) => {
  const {
    t
  } = useTranslation();
  const renderPrice = price => {
    if (!price.amount || price.amount === 0) {
      return /*#__PURE__*/React.createElement("span", {
        key: `${price.amount}-${price.currency}-${price.recurrenceInterval}`
      }, t("FREE"), /*#__PURE__*/React.createElement("br", null));
    } else {
      return /*#__PURE__*/React.createElement("span", {
        key: `${price.amount}-${price.currency}-${price.recurrenceInterval}`
      }, `${getCurrencySymbol(price.currency)} ${price.amount}
                          `, /*#__PURE__*/React.createElement("span", {
        className: "text-lg"
      }, "/", getRecurIntervalSymbol(price.recurrenceInterval)), /*#__PURE__*/React.createElement("br", null));
    }
  };
  const renderSelectText = () => {
    if (selected) {
      return t("Current");
    }
    if (trial && trialDays > 0) {
      return `${trialDays} ${t("day trial")}`;
    }
    return t("Get Started");
  };
  if (price) {
    return /*#__PURE__*/React.createElement("div", {
      className: "min-h-8 border min-w-8 p-8 rounded-xl"
    }, /*#__PURE__*/React.createElement("div", {
      className: "space-y-2"
    }, /*#__PURE__*/React.createElement(HeadingComponent, {
      type: "h2",
      size: "2xl",
      className: "text-purple-700 font-semibold"
    }, name), /*#__PURE__*/React.createElement(TextComponent, null, description), /*#__PURE__*/React.createElement(TextComponent, {
      className: "text-5xl font-semibold"
    }, renderPrice(price))), /*#__PURE__*/React.createElement("div", {
      className: "mt-6"
    }, /*#__PURE__*/React.createElement(NblocksButton, {
      type: selected ? "primary" : "secondary",
      size: "md",
      fullWidth: true,
      onClick: () => didSelect(),
      isLoading: loading
    }, renderSelectText())));
  } else {
    return null;
  }
};
export { PricingCard };